__webpack_require__.p = "https://pa-cosmos-ui.api.prismaaccess.com/tpsdwan-mgt-ui-ui/gov/6d97f66/";